import React from 'react';
import { JCCC_COURSES } from '../../data/jcccDemo';

const PROGRAM_STYLES = {
  'Chef Apprenticeship': 'bg-blue-50 text-blue-700 border-blue-200',
  'Pastry/Baking Certificate': 'bg-amber-50 text-amber-700 border-amber-200',
  'Food & Beverage Management': 'bg-emerald-50 text-emerald-700 border-emerald-200',
};

export default function CompetencyMapPage() {
  const labs = JCCC_COURSES.filter((c) => c.lab);
  const nonLabs = JCCC_COURSES.filter((c) => !c.lab);

  const Card = ({ c }) => (
    <div className="bg-white rounded-lg border border-gray-200 p-5 flex flex-col">
      <div className="flex items-start justify-between gap-3">
        <div>
          <div className="text-lg font-bold text-gray-900">{c.course}</div>
          <div className="text-sm text-gray-600">{c.title} &middot; {c.credits} cr</div>
        </div>
        <span className={`text-xs px-2 py-1 rounded-full border whitespace-nowrap ${PROGRAM_STYLES[c.program] || 'bg-gray-50 text-gray-600 border-gray-200'}`}>
          {c.program}
        </span>
      </div>
      <ul className="mt-4 space-y-1.5 flex-1">
        {c.competencies.map((comp, i) => (
          <li key={i} className="flex gap-2 text-sm text-gray-700">
            <span className="text-blue-600 font-bold">&#10003;</span>
            <span>{comp}</span>
          </li>
        ))}
      </ul>
      {c.lab && (
        <div className="mt-4 pt-3 border-t border-gray-100 text-xs text-gray-500">
          Weekly lab requisitions on the Requisitions page are tagged to these competencies.
          Supports Culinary Arts Practicum I&ndash;VI and ACF Certified Sous Chef&reg; practical domains.
        </div>
      )}
    </div>
  );

  return (
    <div className="max-w-7xl mx-auto px-6 py-8">
      <div className="mb-6">
        <h2 className="text-2xl font-bold text-gray-900">Competency Map</h2>
        <p className="text-sm text-gray-600 mt-1">
          What each lab class delivers &mdash; ACFEF-aligned competencies by course, tied to weekly requisitions.
          Every purchase in this system exists to meet a stated learning outcome.
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {labs.map((c) => <Card key={c.course} c={c} />)}
      </div>
      {nonLabs.length > 0 && (
        <>
          <h3 className="text-lg font-semibold text-gray-800 mt-8 mb-3">Seminar &amp; Management Courses</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {nonLabs.map((c) => <Card key={c.course} c={c} />)}
          </div>
        </>
      )}
      <p className="text-xs text-gray-400 mt-8">
        Demonstration mapping prepared from the JCCC Culinary &amp; Hospitality Programs booklet (Fall 2025).
      </p>
    </div>
  );
}
